import FluentValidator from '@/app/module/fluentValidator'
import CommonClass from '@/app/module/common'

class ExternalLinkValidator extends FluentValidator {
  private name: string = ''

  constructor () {
    super()
    this.name = CommonClass.getServiceFunctionData().external_link.external_link_name
  }

  public validRequireExternalLinkName (key: string, value: string|number): boolean {
    this.errorMessages[key] = ''
    if (!value) {
      this.errorMessages[key] = this.name + '名は必ず入力してください。'
      return true
    }
    return false
  }

  public validMaxLengthExternalLinkName (key: string, value: string): boolean {
    this.errorMessages[key] = ''
    if (value.length > 100) {
      this.errorMessages[key] = this.name + '名は100文字以下で入力してください。'
      return true
    }
    return false
  }

  public validSelectedVarietyType (key: string, value: number): boolean {
    this.errorMessages[key] = ''
    if (value !== 0 && value !== 1) {
      this.errorMessages[key] = '品種の選択値が不正な値となっております。'
      return true
    }
    return false
  }

  public validRequiredVariety (key: string, selectedType: number, value: []): boolean {
    this.errorMessages[key] = ''
    if (selectedType === 0 && value.length === 0) {
      this.errorMessages[key] = '品種は1件以上選択してください。'
      return true
    }
    return false
  }

  public validSelectedDistrictType (key: string, value: number): boolean {
    this.errorMessages[key] = ''
    if (value !== 0 && value !== 1) {
      this.errorMessages[key] = '地区の選択値が不正な値となっております。'
      return true
    }
    return false
  }

  public validRequiredDistrict (key: string, selectedType: number, value: []): boolean {
    this.errorMessages[key] = ''
    if (selectedType === 0 && value.length === 0) {
      this.errorMessages[key] = '地区は1件以上選択してください。'
      return true
    }
    return false
  }
}

export default new ExternalLinkValidator()
